<template>
  <div v-if="doneFetch" class="settings scrollbar">
    <div class="header">
      <h1>Transactions</h1>
      <div class="d-flex align-items-center">
        <div class="date-selector settings__control-group">
          <select v-model="selectYear" class="select">
            <option v-for="(year, i) in years" :key="i" :value="year">
              {{ year }}
            </option>
          </select>
        </div>
      </div>
    </div>
    <span class="subtitle">All purchases and payments made in the selected year.</span>
    <div class="transactions">
      <div class="table-container">
        <v-data-table
          :headers="headers"
          :items="transactions.sort((a,b) => new Date(b.date_generated) - new Date(a.date_generated))"
          item-value="name"
          :items-per-page="-1"
          density="comfortable"
        >
          <template #[`header.date_generated`]>
            <div class="date-col">
              <span>Date Posted</span>
              <!-- <div class="tz-selector">
                <input
                  id="option-local"
                  v-model="selectTimeZone"
                  type="radio"
                  name
                  :value="'local'"
                >
                <label for="option-local">Local</label>
                <input
                  id="option-utc"
                  v-model="selectTimeZone"
                  type="radio"
                  :value="'utc'"
                >
                <label for="option-utc">UTC</label>
              </div> -->
            </div>
          </template>
          <template
            v-for="header in headers" :key=header
            #[`item.${header.key}`]="{ item }"
          >
            <template v-if="header.key ==='amount'">
              {{ formatAmount(item['amount']) }}
            </template>

            <template v-else-if="header.key ==='date_generated'">
              {{ `${item[header.key]}` }}
            </template>

            <template v-else-if="header.key ==='transaction_id'">
              <v-icon v-if="item['method']=='credit_card'" v-tooltip:top-left="`Credit Card`">mdi-credit-card-outline</v-icon>
              <v-icon v-if="item['method']=='generated'" v-tooltip:top-left="`System Generated`">mdi-cog</v-icon>
              <v-icon v-if="item['method']=='coupon'" v-tooltip:top-left="`Coupon`">mdi-tag-outline</v-icon>
              <v-icon v-if="item['method']=='manual'" v-tooltip:top-left="`Coupon`">mdi-account-outline</v-icon>

              <span v-if="item['invoice_number']==''" @click="invoiceClickHandler(item)" class="pointer">{{ `${item[header.key] ? item[header.key] : "-"}` }}</span>
              <span v-else-if="item['invoice_url']==''" @click="invoiceClickHandler(item)" >{{ item['invoice_number'] }}</span>
              <span v-else @click="invoiceClickHandler(item)" class="pointer">{{ item['invoice_number'] }}</span>
            </template>

            <template v-else-if="header.key ==='details'">
              <div class="desc">
                <v-icon v-if="item['type']=='monthly_bill'" v-tooltip="`Monthly Bill`">mdi-calendar-month</v-icon>
                <v-icon v-if="item['type']=='credits'" v-tooltip:top-left="`Credit Top Up`">mdi-wallet-outline</v-icon>
                <v-icon v-if="item['type']=='subscription'" v-tooltip:top-left="`Subscription`">mdi-autorenew</v-icon>

                <div v-if="item['type']=='monthly_bill'" v-tooltip:top-left="`Click For Details`" style="cursor: pointer;">Bill for {{ item['month'] }}/{{ item['year'] }}</div>
                <div v-else-if="item['type']=='credits'" v-tooltip:top-left="`Click For Details`" style="cursor: pointer;">Credit Top Up using {{ item['method'] }}</div>
                <div v-else-if="item['type']=='subscription'" v-tooltip:top-left="`subscription_id: ${item.bill.subscription_id}`" style="cursor: pointer;">{{ SubScriptionDetail(item['bill']) }}</div>
              </div>
            </template>

            <template v-else-if="header.key ==='inv_amount'">
              {{ formatAmount(item['invoice_amount']) }}
            </template>

            <template v-else-if="header.key ==='pay_by'">
              <v-icon v-if="item['invoice_is_paid']" v-tooltip:top-left="`PAID`" style="color:green;">mdi-check-bold</v-icon>
              <v-icon
                v-else
                v-tooltip:top-left="`Not Paid - Click on Payment ID to pay`"
                style="color: red;"
              >
                mdi-alert
              </v-icon>

              {{ item['invoice_is_paid'] ? "PAID" : formatDateOnly(item['invoice_due']) }}
            </template>

            <template v-else>
              {{ `${item[header.key]}` }}
            </template>
          </template>
          <template #bottom />
        </v-data-table>
      </div>
    </div>
  </div>
  <div v-else class="empty-state">
    <div id="loading-visualization"><div class="lds-ring"><div /><div /><div /><div /></div></div>
  </div>
</template>

<script>
import DatastoreConnect from '@/assets/js/DatastoreFunctions/datastore-interface';
import { useToast } from 'vue-toast-notification';
import 'vue-toast-notification/dist/theme-sugar.css';
import SVGIcon from '@/components/SVGIcon.vue';

const $toast = useToast();

export default {
  name: 'Transactions',
  components: {
    SVGIcon,
  },
  data() {
    return {
      dsConn: new DatastoreConnect(this.$store.state.enterpriseServerUrl),
      refreshTimeOut: false,
      headers: [
        {
          title: 'Date Posted', key: 'date_generated', width: '260px', sortable: false, align: 'left',
        },
        {
          title: 'Payment ID', key: 'transaction_id', sortable: false, width: '200px', align: 'left',
        },
        {
          title: 'Details', key: 'details', sortable: false, align: 'left',
        },
        {
          title: 'Invoice Amount', key: 'inv_amount', width: '120px', sortable: false, align: 'right',
        },
        {
          title: 'Payment Due', key: 'pay_by', width: '200px', sortable: false, align: 'left',
        },
        {
          title: 'Amount ($)', key: 'amount', width: '120px', sortable: false, align: 'end',
        },
      ],
      groupBy: [
        {
          key: 'type',
          order: 'asc',
        },
      ],
      orgId: 0,
      costPackage: null,
      selectYear: 0,
      doneFetch: false,
      transactions: [],
      timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
      selectTimeZone: 'local',
      userLocale: navigator.language || 'en-US',
      bills: null,
    };
  },
  computed: {
    user() {
      return this.$store.state.user.user;
    },
    years() {
      const currentYear = new Date().getFullYear();
      const startingYear = 2023;
      const years = [];
      for (let year = startingYear; year <= currentYear; year++) {
        years.push(year);
      }

      return years;
    },
    totalAmount() {
      if (!this.doneFetch) {
        return 0;
      } else {
        return this.transactions.reduce((a, c) => a + c.amount, 0);
      }
    },
  },
  watch: {
    selectTimeZone(val) {
      if (val === 'utc') {
        this.timeZone = 'UTC';
      } else if (val === 'local') {
        this.timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
      }
      this.getTransactions();
    },
    selectYear() {
      this.getTransactions();
    },
  },
  created() {
    if (this.$route.query.org) {
      this.orgId = parseInt(this.$route.query.org);
    }
    this.selectYear = new Date().getFullYear();
  },
  async mounted() {
    await this.getTransactions();
  },
  methods: {
    async invoiceClickHandler(item){
      let url=item['invoice_url'];
      
      await this.dsConn.invoiceUpdate({ transaction_id: item['transaction_id']})
      .then(() => {
        this.getTransactions();
      });
      
      if (url!="") {
        window.open(url); 
      }
    },  
    SubScriptionDetail(sub) {
      const plan = sub['plan'];
      if (!sub.start) return "Subscription";
      const start = this.formatDateOnly(sub.start);
      if (!sub.end) return "Subscription";
      const end = this.formatDateOnly(sub.end);
      const id = sub['subscription_id'];
      return `Subscription:${start} to ${end} id:${id}`;
    },
    formatAmount(amount) {
      const a = amount;
      if (a == 0) return "";
      return a.toFixed(2);
    },
    formatDateOnly(date) {
      date = date.split("T")[0];
      const year = date.split("-")[0];
      const y = parseInt(year, 10);
      if (y < '2000') return '';
      return date;
    },
    async payNow(item) {
      this.amount = item['invoice_amount'];
      this.isLoading = true;
      const dsConn = new DatastoreConnect();
      const success_url = `${window.location.origin}/admin/payment_success`;
      const fail_url = `${window.location.origin}/admin/payment_fail`;
      const ret = await dsConn.topupFunds({
        amount: item['invoice_amount'], success: success_url, fail: fail_url, transaction_id: item['transaction_id'],
      });

      if (ret.result) {
        const url = ret.result['url'];
        if (url.includes("admin/payment_success")) {
          $toast.open({
            queue: true,
            dismissible: true,
            message: ret.result['message'],
            type: "success",
            position: "top",
          });
          this.amount = 0;
        } else if (url.includes("admin/payment_fail")) {
          $toast.open({
            queue: true,
            dismissible: true,
            message: `Top-up failed.`,
            type: "error",
            position: "top",
          });
          this.amount = 0;
        } else {
          this.isLoading = false;
          window.open(url, '_blank');
        }
      }
      this.isLoading = false;
      this.getTransactions();
    },

    async getTransactions() {
      this.doneFetch = false;
      await this.dsConn.retrieveAnnualBill({ organization_id: this.orgId, year: this.selectYear })
        .then((resp) => {
          if (resp.result && Object.keys(resp.result).length > 0) {
            this.parseReport(resp.result);
          } else {
            this.parseReport([]);
          }
          this.doneFetch = true;
        })
        .catch((e) => {
          $toast.open({
            queue: true,
            duration: 5000,
            message: `Error retrieving recent transactions: ${e}`,
            type: "error",
            position: "top",
          });
          this.doneFetch = true;
        });
    },
    async getRecentBills() {
      await this.dsConn.getRecentBills()
        .then((resp) => {
          if (resp.result) {
            this.bills = resp.result;
          } else if (resp.error) {
            throw new Error(resp.errror.message);
          }
        })
        .catch((e) => {
          $toast.open({
            queue: true,
            duration: 5000,
            message: `Error retrieving recent bills: ${e}`,
            type: "error",
            position: "top",
          });
        });
    },

    parseReport(data) {
      const arr = [...data];
      arr.forEach((datum, i) => {
        arr[i].amount = Number(arr[i].change);
        arr[i].date_generated = new Date(arr[i].date).toLocaleString('default', {
          year: 'numeric', month: 'short', day: 'numeric', hour: 'numeric', minute: 'numeric', second: 'numeric', hour12: true, timeZone: this.timeZone,
        });
      });
      this.transactions = arr;
    },
    switchTime() {
      const arr = [...this.transactions];
      arr.forEach((datum, i) => {
        const startDate = new Date(arr[i].start_date).toLocaleString('default', {
          year: 'numeric', month: 'short', day: 'numeric', timeZone: this.timeZone,
        });
        const endDate = new Date(arr[i].end_date).toLocaleString('default', {
          year: 'numeric', month: 'short', day: 'numeric', timeZone: this.timeZone,
        });
        arr[i].period = `${startDate} - ${endDate}`;
        arr[i].date_generated = new Date(arr[i].date_generated).toLocaleString('default', {
          year: 'numeric', month: 'short', day: 'numeric', hour: 'numeric', minute: 'numeric', second: 'numeric', hour12: true, timeZone: this.timeZone,
        });
      });
      this.transactions = arr;
    },
    navigateToClaimCoupons() {
      this.$router.push({ path: '/admin/coupons' });
    },
    getMethod(method, type) {
      if (method === 'coupon') {
        return "Coupon";
      } else {
        return "Credit Card";
      }
    },
  },
};
</script>

<style lang="scss" scoped>

.v-icon {
  padding-right: 30px;
  color: rgb(51, 108, 142);
  font-size: 26px;       /* controls icon size */
}

.desc {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
}

.flex-col {
  display: flex;
  flex-direction: column;
}

.refresh-usage {
  width: fit-content;
}
.settings {
  display: flex;
  flex-direction: column;
  width: 100%;
  min-width: 400px;
  height: 100%;
  padding: 30px;
  overflow-y: auto;
}

.empty-state {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  position: relative;
  width: 100%;
  height: 100%;
}

.date-selector {
  width: 150px;
  display: flex;
  flex-direction: row;
  margin-left: 20px;
  font-size: 1rem;
  font-weight: 500;

  select + select {
    margin-left: 20px;
  }

  button {
    margin-left: 20px;
  }
}

.header {
  font-size: 1.2rem;
  font-weight: 700;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
}

.subtitle {
  font-size: 0.9rem;
}

.pointer {
  cursor: pointer;
}

.pointer:hover {
  color: blue;
  border-bottom: 2px solid ;
}


.icon {
  width: fit-content;
  display: flex;
  align-items: center;
  justify-content: center;
}

.transactions {
  .radio-group {
    display: inline-block;
    margin: 10px 0 20px 0;
    border-radius: 5px;
    overflow: hidden;
    border: solid 1px black
  }

  .radio-group input[type="radio"] {
    position: absolute;
    opacity: 0;
    pointer-events: none;
  }

  .radio-group input[type="radio"] + label {
    min-width: 6rem;
    max-width: 50%;
    text-align: center;
    display: inline-block;
    cursor: pointer;
    font-size: 0.9rem;
    line-height: 1.5;
    padding: 5px 20px;
    transition: all 0s ease;
    @include themify() {
      background: themed('card-color');
      color: themed('body-text-color');
    }
  }

  .radio-group input[type="radio"]:not(:disabled):hover + label {
    @include themify() {
      background: themed('color-primary-300');
      color: themed('primary-text-color');
    }
  }

  .radio-group input[type="radio"]:checked + label,
  .radio-group input[type="radio"]:checked:hover + label {
    opacity: 1;
    z-index: 1;
    @include themify() {
      background: themed('color-primary');
      color: themed('primary-text-color');
    }
  }

  .table-container {
    width: 100%;
    padding: 15px;
    border-radius: 8px;
    margin-top: 20px;
    box-shadow: 1px 1px 4px 1px rgba(0, 0, 0, 0.2), 0 0 1px 1px rgba(0, 0, 0, 0.05);
    @include themify() {
      background: themed('card-color');
      color: themed('body-text-color');

    }
  }

  :deep(tbody tr:nth-of-type(odd)) {
    background-color: rgba(0, 0, 0, .05);
  }
  .table-flex-end {
    display: flex;
    justify-content: end;

      span {
      font-size: 1rem;
      font-weight: 600;
    }
  }
  .total-credit-group{
    text-align: end;
    font-weight: 550;

    span {
      margin-left: auto;
      font-size: 1.0rem;
    }
  }

  .radio-group {
    display: inline-block;
    margin: 10px 0 20px 0;
    border-radius: 5px;
    overflow: hidden;
    border: solid 1px black
  }

  .radio-group input[type="radio"] {
    position: absolute;
    opacity: 0;
    pointer-events: none;
  }

    .radio-group input[type="radio"] + label {
      min-width: 6rem;
      max-width: 50%;
      text-align: center;
      display: inline-block;
      cursor: pointer;
      font-size: 0.9rem;
      line-height: 1.5;
      padding: 5px 20px;
      transition: all 0s ease;
      @include themify() {
        background: themed('card-color');
        color: themed('body-text-color');
      }
    }

    .radio-group input[type="radio"]:not(:disabled):hover + label {
      @include themify() {
        background: themed('color-primary-300');
        color: themed('primary-text-color');
      }
    }

    .radio-group input[type="radio"]:checked + label,
    .radio-group input[type="radio"]:checked:hover + label {
      opacity: 1;
      z-index: 1;
      @include themify() {
        background: themed('color-primary');
        color: themed('primary-text-color');
      }
    }
}

.date-col {
  display: flex;
  flex-direction: row;
  justify-content: left;

  .tz-selector {
    margin-left: 5px;

    input[type="radio"] {
      display: none;
    }

    label {
      padding: 2px 5px;
      width: fit-content;
      font-size: 0.85rem;
      font-weight: bold;
      color: var(--gray-500);
      cursor: pointer;
    }

     input[type="radio"]:checked+label {
      @include themify() {
        color: themed('color-primary-500');
      }
    }
  }
}

</style>
